

export default {
	props: {
		title: { type: String, default: '' },
		visible: { required: true, type: Boolean },
		onClose: { type: Function, default: undefined }
	},
	data() {
		return {
			minimized: false
		};
	},
	watch: {
		title() {
			this.minimized = false;
		}
	},
	created() {
		this._onKeydown = (e: KeyboardEvent) => {
			if (e.key === 'Escape' && this.visible) {
				this.handleClose();
			}
		};
		document.addEventListener('keydown', this._onKeydown);
	},
	destroyed() {
		document.removeEventListener('keydown', this._onKeydown);
	},
	methods: {
		handleMinimize() {
			this.minimized = !this.minimized;
		},
		handleClose() {
			if (typeof this.onClose === 'function') {
				this.onClose();
			}
		}
	}
};
